var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconoboleto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.02 38.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PLANO"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m24.18,0H4.84C2.17,0,0,2.17,0,4.84v33.7l5.92-4.05,4.31,2.94,4.3-2.94,4.3,2.94,4.3-2.94,5.91,4.05V4.84c0-2.67-2.17-4.84-4.84-4.84Zm-4.84,22.57H6.45v-3.22h12.9v3.22Zm3.22-8.06H6.45v-3.22h16.12v3.22Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoboleto);
export default __webpack_public_path__ + "static/media/icono boleto.f063a0dcf90c6ef607c53e7a3599c7d1.svg";
export { ForwardRef as ReactComponent };